'use strict';

import angular from 'angular';

import modalDirective from '../rest-modal';

import queueFromIncidentTemplate from './queue-from-incident.html';

const MODULE_NAME = 'daupler.incidents.compnents.buttons.cityworksServiceRequests';

var app = angular.module(MODULE_NAME, [
	'brg.components.inputs',
]);

app.directive('queueCityworksServiceRequestFromIncident', modalDirective({
	template: queueFromIncidentTemplate,
}));

export default MODULE_NAME;
